import {Component, Input, OnInit} from '@angular/core';
import {AppConfigService} from "../../../config/app-config.service";

@Component({
  selector: 'app-descriptor-metadata-text',
  templateUrl: './descriptor-metadata-text.component.html',
  styleUrls: ['./descriptor-metadata-text.component.scss']
})
export class DescriptorMetadataTextComponent implements OnInit {

  @Input() fullText: any;
  @Input() strippedVersion = false;
  @Input() disableShowMore: true;

  maxText: number;

  @Input() showMulti = false;
  showMore = false;
  arrayText;

  constructor(private appConfig: AppConfigService) {
  }

  ngOnInit() {
    if (this.showMulti || (this.strippedVersion && this.fullText.type !== 'string')) {
      this.showMulti = true;
      if (!Array.isArray(this.fullText.value)) {
        this.fullText.value = [this.fullText.value];
      }
    } else if (this.fullText.type === 'string') {
      this.fullText =  this.fullText.value;
    }
    this.maxText = this.appConfig.showMoreConfig.maxText;
  }

  setShowMore(): void {
    this.showMore = true;
  }

  setShowLess(): void {
    this.showMore = false;
  }

  cutText() {
    return this.fullText.slice(0, this.maxText);
  }
}
